// Due pulsanti al massimo, uno per kind. Il conteggio in etichetta resta corto.
const MAX_SUGGESTIONS = 2;
const MAX_SUGGESTION_COUNT = 99;

const SUGGESTION_KEYS = {
  CHECKLIST: "chatbot.suggestions.checklist",
  MY_TICKETS: "chatbot.suggestions.myTickets",
} as const;

type SuggestionKind = keyof typeof SUGGESTION_KEYS;

type VisibleSuggestion = {
  kind: SuggestionKind;
  count: number;
  capped: boolean;
};

// Solo i due kind noti, confrontati per valore: una chiave ereditata
// (constructor, toString) non diventa un pulsante.
const suggestionKind = (kind: unknown): SuggestionKind | null => {
  if (kind === "CHECKLIST" || kind === "MY_TICKETS") {
    return kind;
  }
  return null;
};

// Il backend manda un intero. Stringhe, oggetti e Infinity non entrano
// nell'etichetta: niente HTML, markdown o testi lunghi dal payload.
const suggestionCount = (
  count: unknown,
): {count: number; capped: boolean} | null => {
  if (typeof count !== "number" || !Number.isInteger(count) || count < 1) {
    return null;
  }
  if (count > MAX_SUGGESTION_COUNT) {
    return {count: MAX_SUGGESTION_COUNT, capped: true};
  }
  return {count, capped: false};
};

const readSuggestions = (value: unknown): VisibleSuggestion[] => {
  if (!Array.isArray(value)) {
    return [];
  }
  const seen = new Set<SuggestionKind>();
  const result: VisibleSuggestion[] = [];
  for (const item of value) {
    if (!item || typeof item !== "object") {
      continue;
    }
    const record = item as {kind?: unknown; count?: unknown};
    const kind = suggestionKind(record.kind);
    const count = suggestionCount(record.count);
    if (!kind || !count || seen.has(kind)) {
      continue;
    }
    seen.add(kind);
    result.push({kind, count: count.count, capped: count.capped});
    if (result.length >= MAX_SUGGESTIONS) {
      break;
    }
  }
  return result;
};

export {SUGGESTION_KEYS, readSuggestions};
export type {SuggestionKind, VisibleSuggestion};
